import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0;

  .boxHeading {
    color: #262626;
    font-size: 40px;
    font-weight: 700;
    line-height: normal;
  }

  .boxPara {
    color: #424242;
    text-align: justify;
    font-size: 23px;
    font-weight: 600;
    line-height: normal;
  }

  .box-bg-blue {
    position: absolute;
    top: 30%;
    right: -10rem;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: var(--bg-muted);
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    filter: blur(90px);
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  .box-bg-yellow {
    position: absolute;
    top: 30%;
    left: 0rem;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: rgba(243, 194, 163, 0.5);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    filter: blur(90px);
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  /* Responsive styles */
  @media (max-width: 992px) {
    .boxHeading {
      font-size: 32px;
    }

    .boxPara {
      font-size: 20px;
    }

    .box-bg-blue,
    .box-bg-yellow {
      width: 200px;
      height: 200px;
      filter: blur(70px);
    }
  }

  @media (max-width: 768px) {
    .boxHeading {
      font-size: 28px;
    }

    .boxPara {
      font-size: 18px;
    }

    .box-bg-blue {
      right: -5rem;
      top: 40%;
    }

    .box-bg-yellow {
      left: -5rem;
      top: 40%;
    }
  }

  @media (max-width: 576px) {
    .boxHeading {
      font-size: 24px;
    }
.sabhaSaarFrame{
  width : 100%;
}
    .boxPara {
      font-size: 16px;
    }

    .box-bg-blue,
    .box-bg-yellow {
      display: none; /* Optional: hide blurry backgrounds on very small screens */
    }
  }
`;

export default Wrapper;
